import { Module } from 'vuex';
import { DoorbraakStore } from '@/store';

import { Component } from 'vue-property-decorator';

export interface ModalInfo {
  modal: typeof Component;
  data: any;
}

export interface ModalStore {
  modal: ModalInfo | null;
}

export const modalStore: Module<ModalStore, DoorbraakStore> = {
  namespaced: true,
  state: {
    modal: null,
  },
  mutations: {
    openModal(state, modal: ModalInfo) {
      state.modal = modal;
    },

    closeModal(state) {
      state.modal = null;
    },
  },
};
